import TileLink from 'components/TileLink/TileLink';

export default TileLink;
